// filtr
function filter() {
  // otevření okna
  $('.js-filter-open').on('click', function () {
    // otevření okna
    $(this).prev('.filtering__window').addClass('is-open');
    $('body').addClass('is-unscrollable');
  });

  // zavření filter okna
  $('.js-filter-close').on('click', function (event) {
    if ($(this).attr('type') === 'submit') {
      setTimeout(() => {
        $(this).closest('.filtering__window').removeClass('is-open');
        $('body').removeClass('is-unscrollable');
      }, 500);
      return;
    }

    event.preventDefault();
    $(this).closest('.filtering__window').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  });
}
